import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  orgPage: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  orgInfo: { data: null, loading: false },
  ownerOrgs: { data: [], loading: false },
  ownerBrands: { data: [], loading: false },
  storeBrands: { data: [], loading: false },
  unauthBrands: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  authedBrands: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  competBrands: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  exchanges: { data: [], loading: false },
  customerTypes: { data: [], loading: false },
  orderResult: { data: null, loading: false },
  orderOrg: { data: null, loading: false },
  orderPrice: { data: null, loading: false },
  steps: { step1: null, step2: [], step3: null, step5: null },
  dialog: { type: '', visible: false, loading: false },
  confirm: { type: '', title: '', content: '', visible: false, loading: false },
  search: { pageNum: 1, pageSize: 10 },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
